const apiConfig = {
    downloadAsPDF: {
        url: '/xms/v1/downloadFile',
        method: 'POST',
        server: 'xms_srv'
    },
    locationApi: {
        url: '/xms/v1/nearBySearch/',
        method: 'GET',
        server: 'xms_srv'
    },
    geocodeApi: {
        url: '/xms/v1/geocode/',
        method: 'GET',
        server: 'xms_srv'
    },
    mailinator: {
        url: '/xms/v1/mailinator',
        method: 'POST',
        server: 'xms_srv'
    },
    svgIcons: {
        url: '/hotel/icons-sprite.svg',
        method: 'GET',
        server: 'static_srv'
    },
    deleteQuotations: {
        url: '/hms/v1/delete-quotation',
        method: 'DELETE',
        server: 'hms_srv'
    },
    searchQuotations: {
        url: '/hms/v1/search-quotation',
        method: 'POST',
        server: 'hms_srv'
    },
    addQuotation: {
        url: '/hms/v1/add-quotation',
        method: 'POST',
        server: 'hms_srv'
    },
    addToFavourite: {
        url: '/hms/v1/save-favourite',
        method: 'POST',
        server: 'hms_srv'
    },
    getSearchResult: {
        url: '/hms/v1/hotel-search',
        method: 'POST',
        server: 'hms_srv'
    },
    getRegionInfo: {
        url: '/hms/v1/supplier/region/fetch-regioninfo',
        method: 'POST',
        server: 'hms_srv'
    },
    billingEntityInfo: {
        url: '/gms/v1/billing-entity/search',
        method: 'POST',
        server: 'gms_srv'
    },
    userReview: {
        url: '/hms/v1/user-review',
        method: 'POST',
        server: 'hms_srv'
    },
    getHotelSearchIds: {
        url: '/hms/v1/hotel-searchquery-list',
        method: 'POST',
        server: 'hms_srv'
    },
    menu: {
        url: '/xms/v1/menubar/',
        method: 'POST',
        server: 'xms_srv'
    },
    getCityList: {
        url: '/xms/v1/searchApi',
        method: 'POST',
        server: 'xms_srv'
    },
    logout: {
        url: '/ums/v1/logout',
        method: 'GET',
        server: 'ums_srv'
    },
    getDocuments: {
        url: '/gms/v1/fetch-documents',
        method: 'POST',
        server: 'gms_srv'
    },
    getHotelDetails: {
        url: '/hms/v1/hotelDetail-search',
        method: 'POST',
        server: 'hms_srv'
    },
    tcsRepricing: {
        url: '/hms/v1/re-pricing',
        method: 'POST',
        server: 'hms_srv'
    },
    getPaymentData: {
        url: '/pms/v1/payment-modes/',
        method: 'POST',
        server: 'pms_srv'
    },
    getReviewData: {
        url: '/hms/v1/hotel-review',
        method: 'POST',
        server: 'hms_srv'
    },
    getHotelPolicy: {
        url: '/hms/v1/hotel-cancellation-policy',
        method: 'POST',
        server: 'hms_srv'
    },
    hotelBook: {
        url: '/oms/v1/hotel/book',
        method: 'POST',
        server: 'oms_srv'
    },
    refreshToken: {
        url: '/ums/v1/refresh-token',
        method: 'GET',
        server: 'ums_srv'
    },
    getConfirmData: {
        url: '/oms/v1/hotel/booking-details',
        method: 'POST',
        server: 'oms_srv'
    },
    validatePayment: {
        url: '/oms/v1/hotel/fare-validate',
        method: 'POST',
        server: 'oms_srv'
    },
    hotelConfirmBook: {
        url: '/oms/v1/hotel/confirm-book',
        method: 'POST',
        server: 'oms_srv'
    },
    getInvoice: {
        url: '/oms/v1/hotel/invoice',
        method: 'POST',
        server: 'oms_srv'
    },
    leftNav: {
        url: '/xms/v1/leftnav/',
        method: 'GET',
        server: 'xms_srv'
    },
    saveMarkup: {
        url: '/hms/v1/user-fee/update',
        method: 'POST',
        server: 'oms_srv'
    },
    'errorLog': {
        url: '/xms/v1/error-log/',
        method: 'POST',
        server: 'xms_srv'
    },
    amendmentInvoice: {
        url: '/oms/v1/hotel/amendment/invoice/',
        method: 'GET',
        server: 'oms_srv'
    },
    register: {
        url: '/ums/v1/register',
        method: 'POST',
        server: 'ums_srv'
    },
    login: {
        url: "/ums/v1/sign-in",
        method: "POST",
        server: "ums_srv"
    },
    forget: {
        url: '/ums/v1/reset-password',
        method: 'POST',
        server: 'ums_srv'
    },
    otp: {
        url: '/gms/v1/otp-generate',
        method: 'POST',
        server: 'gms_srv'
    },
    // B2C My Bookings
    bookingList: {
        url: "/xms/v1/bookingListHotel/",
        method: "POST",
        server: "xms_srv"
    },
    'amendments-itinerary': {
        url: "/xms/v1/amendments/hotel/itinerary/",
        method: "POST",
        server: "xms_srv"
    },
    'initialise-amendment': {
        url: "/xms/v1/amendments/hotel/initialise",
        method: "POST",
        server: "xms_srv"
    },
    'applyVoucher': {
        url: '/pms/v1/voucher-discount',
        method: 'POST',
        server: 'pms_srv'
    },
    redeemPoints: {
        url: '/pms/v1/redeem-points',
        method: 'POST',
        server: 'pms_srv'
    },
    "user-due-info": {
        url: "/xms/v1/user-due-info",
        method: "GET",
        server: "xms_srv"
    },
    guestLogin: {
        url: "/ums/v1/default-token",
        method: "GET",
        server: "ums_srv"
    },
    "footer": {
        url: '/xms/v1/footer/',
        method: "POST",
        server: "xms_srv"
    },
    "getUserDetails": {
        url: '/xms/v1/user/manage-details',
        method: "POST",
        server: "xms_srv"
    },
    "panValidate": {
        url: '/xms/v1/verifyDocument',
        method: "POST",
        server: "xms_srv"
    },
    "panValidateName": {
        url: '/xms/v1/matchName',
        method: "POST",
        server: "xms_srv"
    },
    'getBulkPolicy': {
        url: '/xms/v1/hotel/get-policy',
        method: "POST",
        server: "xms_srv"
    },
    'searchHotelName': {
        url: '/xms/v1/hotel/es/search',
        method: "POST",
        server: "xms_srv"
    },
    'linked-users-info': {
        url: "/xms/v1/linked-user-details",
        method: "POST",
        server: "xms_srv",
    },
    'switch-user': {
        url: "/xms/v1/toggle-linked-user",
        method: "POST",
        server: "xms_srv"
    },
    'recentBookingInfo': {
        url: '/xms/v1/bookingListHotel/',
        method: 'POST',
        server: 'xms_srv'
    },
    'multiplePaymentMethod': {
        url: '/pms/v1/payment-modes/list',
        method: "POST",
        server: "pms_srv"
    },
    'uploadDocuments': {
        url: '/xms/v1/upload/',
        method: "POST",
        server: "xms_srv"
    },
    "getUserData": {
        url: '/ums/v1/users',
        method: 'POST',
        server: 'ums_srv'
    },
    'languageTranslate': {
        url: '/xms/v1/showLangTranslate',
        method: 'POST',
        server: 'xms_srv'
    },
    "share-ticket": {
        url: '/oms/v1/hotel/share-ticket',
        method: 'POST',
        server: 'oms_srv'
    },
    getOpenBookingDetails: {
        url: '/oms/v1/hotel/booking-details-hotelier',
        method: 'POST',
        server: 'oms_srv'
    },
    hccUpdateOpenApi: {
        url: '/oms/v1/hotel/hcn/hcn-from-hotelier',
        method: 'POST',
        server: 'oms_srv'
    },
    specialRequest: {
        url: '/oms/v1/hotel/update-ssr',
        method: 'POST',
        server: 'oms_srv'
    },
    airBookingDetails: {
        url: '/xms/v1/bookingDetails',
        method: "POST",
        server: "xms_srv"
    }

};

export default apiConfig;
